import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
};

const DraftWaldogramsIcon = ({
  color = '#B5BCBD',
  size = '24',
  id = 'draft-waldogram-icon',
  ...props
}) => (
  <svg
    width={size}
    viewBox="0 0 30 28"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <path
        d="M27.418 14.606a2.7 2.7 0 0 1 1.002.189c.292.115.556.288.779.509a2.003 2.003 0 0 1 .583 1.654l-1.012 9.066a1.87 1.87 0 0 1-.273.78 2.345 2.345 0 0 1-.576.625 2.93 2.93 0 0 1-1.733.57v.001H3.597c-.315 0-.63-.052-.93-.153a2.756 2.756 0 0 1-.797-.418 2.348 2.348 0 0 1-.576-.626 1.869 1.869 0 0 1-.273-.779L.011 16.957a2.008 2.008 0 0 1 .115-.906 2.03 2.03 0 0 1 .477-.747c.222-.22.487-.394.779-.51.319-.125.658-.19 1-.188h25.036zm-7.337 4.602c-.17 0-.34.031-.5.09-.15.055-.29.137-.411.242a1.172 1.172 0 0 0-.286.353 1.005 1.005 0 0 0-.108.432h-.001l-.05 1.622h-7.66l-.05-1.622a.991.991 0 0 0-.11-.432 1.162 1.162 0 0 0-.289-.353 1.372 1.372 0 0 0-.412-.243 1.495 1.495 0 0 0-.499-.09c-.17 0-.335.031-.493.09-.147.056-.28.137-.395.243a1.068 1.068 0 0 0-.344.794l.133 2.692a.968.968 0 0 0 .12.412c.07.128.164.242.278.335.123.098.265.174.415.223.154.055.318.084.481.084h9.992c.163 0 .327-.03.48-.084.146-.05.282-.126.4-.223.114-.093.209-.207.28-.335a.984.984 0 0 0 .118-.412l.133-2.701a.975.975 0 0 0-.336-.785 1.222 1.222 0 0 0-.393-.243 1.398 1.398 0 0 0-.493-.09zM23.436 0c.7 0 1.296.504 1.415 1.193l1.929 11.258h-2.89l-1.632-9.682a.218.218 0 0 0-.23-.183H7.764a.219.219 0 0 0-.217.183l-1.643 9.682h-2.89L4.94 1.193A1.436 1.436 0 0 1 6.356 0h17.08zm-3.358 9.545a1.212 1.212 0 1 1 0 2.425H9.714a1.212 1.212 0 1 1 0-2.425h10.364zm-.773-4.561a1.212 1.212 0 1 1 0 2.424h-8.819a1.212 1.212 0 1 1 0-2.424h8.82z"
        id={`${id}-a`}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use xlinkHref={`#${id}-a`} />
      </mask>
      <path
        fill={color}
        mask={`url(#${id}-b)`}
        d="M-6.484-6.484h42.763v40.968H-6.484z"
      />
    </g>
  </svg>
);

DraftWaldogramsIcon.propTypes = propTypes;

export default DraftWaldogramsIcon;
